import Alpine from 'alpinejs'

window.Alpine = Alpine // Add Apline scripts below this line, but BEFORE Alpine.start()

Alpine.start() // Initialize Alpine